import { Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import { isEqual } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import DtoEvent from '../../../../events/dto/DtoEvent'
import DtoQualitometerLight from '../../../../quality/dto/DtoQualitometerLight'
import NetworkLinkDto from '../../../../referencial/components/network/dto/NetworkLinkDto'
import { hasValue } from '../../../../utils/NumberUtil'
import { PARAMETER_PANEL, PLANNING_PANEL, STATION_PANEL } from '../../../constants/CampaignConstants'
import CampaignPlanningDto from '../../../dto/CampaignPlanningDto'
import MapCampaignStation from '../MapCampaignStation'
import SelectStation from '../SelectStation'
import ListQualityCampaignStation from './ListQualityCampaignStation'
import ParameterPopin from './ParameterPopin'
import ParametersPanel from './ParametersPanel'
import PlanningsPanel from './PlanningsPanel'
import PlanningStepper from './stepper/PlanningStepper'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import Tabs from 'components/Tabs'

class TabPanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isStationsInList: true,
            tmpSelectedStations: [...props.selectedStations],
            tmpSelectedParameters: [...props.selectedParameters],
            selectedSelections: props.selectedSelections ? [...props.selectedSelections] : [],
            tmpPlanning: {},
            openStationPopup: false,
            openParameterPopup: false,
            openPlanningPopup: false,
            parameterListCode: props.parameterListCode,
        }
    }

    componentDidUpdate = prevProps => {
        if (!isEqual(this.props.selectedStations, prevProps.selectedStations)) {
            this.setState({ tmpSelectedStations: [...this.props.selectedStations] })
        }
        if (!isEqual(this.props.selectedParameters, prevProps.selectedParameters)) {
            this.setState({ tmpSelectedParameters: [...this.props.selectedParameters] })
        }
        if (!isEqual(this.props.selectedSelections, prevProps.selectedSelections)) {
            this.setState({ selectedSelections: [...this.props.selectedSelections] })
        }
    }

    onCloseStationPopup = () => this.setState({
        openStationPopup: false,
        tmpSelectedStations: [...this.props.selectedStations],
    })

    onValidateStationPopup = () => {
        this.props.onChangeStation(this.state.tmpSelectedStations)
        this.setState({ openStationPopup: false })
    }

    onCloseParameterPopup = () => this.setState({ openParameterPopup: false })

    onValidateParameterPopup = (selectedParameters, selectedSelections) => {
        this.props.onChangeParameter(selectedParameters, selectedSelections)
        this.setState({ openParameterPopup: false })
    }

    onClosePlanningPopup = () => this.setState({ openPlanningPopup: false, tmpPlanning: {}, indexPlanning: undefined })

    onValidatePlanningPopup = () => {
        const {
            tmpPlanning,
            indexPlanning,
        } = this.state
        this.props.onUpdatePlanning(tmpPlanning, indexPlanning)
        this.setState({ openPlanningPopup: false, tmpPlanning: {}, indexPlanning: undefined })
    }

    onChangePlanning = change => {
        this.setState({ tmpPlanning: { ...this.state.tmpPlanning, ...change } })
    }

    onAddNewPlanning = () => {
        this.setState({
            openPlanningPopup: true,
            tmpPlanning: {
                stationsPlan: this.props.selectedStations.map(({ id }) => id),
                parametersPlan: [...this.props.selectedParameters],
                selection: this.props.parameterListCode,
            },
        })
    }

    render = () => {
        const {
            isStationsInList,
            tmpSelectedStations,
            tmpPlanning,
            openStationPopup,
            openParameterPopup,
            openPlanningPopup,
            selectedSelections,
            indexPlanning,
        } = this.state
        const {
            editMode,
            stations,
            networkLinks,
            selectedStations,
            selectedParameters,
            onDeleteParameter,
            onDeletePlanning,
            onUpdateParameter,
            campaignEvents,
            plannings,
            onDeleteStation,
            accessibilities = [],
        } = this.props

        const stationsSelected = selectedStations.map(station => stations.find(s => s.id === station.id)).filter(s => s)

        const nbStation = selectedStations.length
        const stationTitle = `${i18n.stations} (${nbStation})`

        const nbParameter = selectedParameters.length
        const nbSelection = selectedSelections.length
        const parameterTitle = `${i18n.parameters} (${nbParameter}) / ${i18n.selections} (${nbSelection})`

        const nbPlanning = plannings.length
        const planningTitle = `${i18n.plannings} (${nbPlanning})`

        return (
            <>
                <Tabs
                    defaultTab={STATION_PANEL}
                    tabs={[
                        {
                            constant: STATION_PANEL,
                            label: stationTitle,
                            actions: [
                                {
                                    icon: 'note_add',
                                    onClick: () => this.setState({ openStationPopup: true }),
                                    displayed: editMode,
                                },
                                {
                                    icon: 'map',
                                    onClick: () => this.setState({ isStationsInList: false }),
                                    displayed: isStationsInList,
                                },
                                {
                                    icon: 'list',
                                    onClick: () => this.setState({ isStationsInList: true }),
                                    displayed: !isStationsInList,
                                },
                            ],
                        },
                        {
                            constant: PARAMETER_PANEL,
                            label: parameterTitle,
                            actions: [
                                {
                                    icon: 'note_add',
                                    onClick: () => this.setState({ openParameterPopup: true }),
                                    displayed: editMode,
                                },
                            ],
                        },
                        {
                            constant: PLANNING_PANEL,
                            label: planningTitle,
                            actions: [
                                {
                                    icon: 'note_add',
                                    onClick: this.onAddNewPlanning,
                                    displayed: editMode,
                                },
                            ],
                        },
                    ]}
                >
                    {activeTab => (
                        <>
                            {activeTab === STATION_PANEL && isStationsInList && (
                                <ListQualityCampaignStation
                                    editMode={editMode}
                                    onDeleteStation={onDeleteStation}
                                    accessibilities={accessibilities}
                                    stations={stationsSelected}
                                />
                            )}
                            {activeTab === STATION_PANEL && !isStationsInList && (
                                <MapCampaignStation
                                    selectedStations={selectedStations}
                                    stations={stationsSelected}
                                    stationType={'quality'}
                                    accessibilities={accessibilities}
                                    editMode={editMode}
                                />
                            )}
                            {activeTab === PARAMETER_PANEL && (
                                <ParametersPanel
                                    selectedParameters={selectedParameters}
                                    selectedSelections={selectedSelections}
                                    onUpdateParameter={onUpdateParameter}
                                    onDeleteParameter={onDeleteParameter}
                                    editMode={editMode}
                                />
                            )}
                            {activeTab === PLANNING_PANEL && (
                                <PlanningsPanel
                                    plannings={plannings}
                                    editMode={editMode}
                                    selectedStations={selectedStations}
                                    selectedParameters={selectedParameters}
                                    onDelete={onDeletePlanning}
                                    onUpdate={(planning, index) => this.setState({
                                        tmpPlanning: { ...planning },
                                        indexPlanning: index,
                                        openPlanningPopup: true,
                                    })}
                                    onDuplicate={planning => this.setState({
                                        tmpPlanning: { ...planning },
                                        openPlanningPopup: true,
                                    })}
                                />
                            )}
                        </>
                    )}
                </Tabs>
                <Dialog
                    onClose={this.onCloseStationPopup}
                    fullWidth
                    maxWidth='xl'
                    slotProps={{
                        paper: {
                            sx: {
                                minHeight: '90vh',
                            },
                        },
                    }}
                    open={openStationPopup}
                >
                    <DefaultDialogTitle
                        title={i18n.selectStations}
                        onClose={this.onCloseStationPopup}
                    />
                    <DialogContent>
                        <SelectStation
                            stations={stations}
                            networkLinks={networkLinks}
                            selectedStations={tmpSelectedStations}
                            campaignEvents={campaignEvents}
                            stationType={'quality'}
                            onChangeSelectedStation={tmpStations => this.setState({ tmpSelectedStations: tmpStations })}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onValidateStationPopup} variant='contained' color='primary'>
                            {i18n.validate}
                        </Button>
                    </DialogActions>
                </Dialog>
                <ParameterPopin
                    onChange={obj => this.setState(obj)}
                    isOpen={openParameterPopup}
                    selectedParameters={selectedParameters}
                    selectedSelections={selectedSelections}
                    onClose={this.onCloseParameterPopup}
                    onValidate={this.onValidateParameterPopup}
                />
                <PlanningStepper
                    isOpen={openPlanningPopup}
                    isNew={hasValue(indexPlanning)}
                    onClose={this.onClosePlanningPopup}
                    onValidate={this.onValidatePlanningPopup}
                    onChange={this.onChangePlanning}
                    planning={tmpPlanning}
                    selectedStations={selectedStations}
                    selectedSelections={selectedSelections}
                    stations={stations}
                    selectedParameters={selectedParameters}
                />
            </>
        )
    }
}

TabPanel.propTypes = {
    selectedStations: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
    })),
    selectedParameters: PropTypes.arrayOf(PropTypes.shape({
        parameterCode: PropTypes.string,
        fractionCode: PropTypes.string,
        supportCode: PropTypes.string,
        unitCode: PropTypes.string,
        placeCode: PropTypes.string,
    })),
    selectedSelections: PropTypes.arrayOf(PropTypes.string),
    editMode: PropTypes.bool,
    stations: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualitometerLight)),
    parameterListCode: PropTypes.string,
    accessibilities: PropTypes.arrayOf(PropTypes.shape({})),
    campaignEvents: PropTypes.arrayOf(PropTypes.instanceOf(DtoEvent)),
    networkLinks: PropTypes.arrayOf(PropTypes.instanceOf(NetworkLinkDto)),
    plannings: PropTypes.arrayOf(PropTypes.instanceOf(CampaignPlanningDto)),
    onChangeStation: PropTypes.func,
    onChangeParameter: PropTypes.func,
    onUpdatePlanning: PropTypes.func,
    onUpdateParameter: PropTypes.func,
    onDeleteStation: PropTypes.func,
    onDeleteParameter: PropTypes.func,
    onDeletePlanning: PropTypes.func,
}

const mapStateToProps = store => ({
    campaignEvents: store.CampaignReducer.campaignEvents,
    networkLinks: store.QualityReducer.networkLinks,
})

export default connect(mapStateToProps)(TabPanel)